// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatListMineBody = {
  chatType?: "pool" | "private" | "standalone" | null;
  cursor?: string | null;
  limit?: number | null;
};

export type typeChatListMineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      chatId: string;
      chatType: "pool" | "private" | "standalone";
      title: string;
      photoMediaId?: string | null;
      poolId?: string | null;
      lastMessagePreview?: string | null;
      lastMessageAtIso: string;
      unreadCount: number;
      isMuted: boolean;
      isEnabled: boolean;
      isPendingApproval: boolean;
      isSoleAdmin?: boolean;
      lastMessageSenderDisplayName?: string | null;
      lastMessageSenderIsSelf: boolean;
      avatarUrl?: string | null;
    }[];
    nextCursor?: string | null;
    hasPendingRequestBadge: boolean;
    totalUnreadCount: number;
  };
};

export type typeChatListMineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListMineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListMineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatListMineBody = {
  type: "object",
  properties: {
    chatType: {
      oneOf: [
        { type: "string", enum: ["pool", "private", "standalone"] },
        { enum: [null] },
      ],
    },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatListMine(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatListMineBody);
  }

  return async function postChatListMine(
    payload: typeChatListMineBody,
  ): Promise<typeChatListMineOutput200 | typeChatListMineOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatListMine" failed before calling the network. #b01064b7de75`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b01064b7de75" },
        },
        data: null,
      } as typeChatListMineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/list-mine`,
      httpMethod: "POST",
      options,
    })) as typeChatListMineOutput200 | typeChatListMineOutput400;
  };
}
